import {
  COMMON_INPUT,
  BASE_LAYER_CHANGE,
  DISPLAY_BASELAYER_PANEL,
  DISPLAY_ABOUT_MODAL,
} from "../types";
import L from "leaflet";
import urls from "../../urls";
const initialState = {
  indiamapcenter: window.innerWidth>1000?[22.12539, 79.00164]:[20.13,80.58],

  minZoom: 3,
  maxZoom: 15,
  zoom: window.innerWidth>1000?4:3,
  layers: urls.map_layer,
  layers1: urls.s_layer,
  url: urls.bhuvan_map,
  url1: urls.satellite,

  baseLayers: false,
  baseLayers1: false,
  baselayerselected: "Map",
  baselayerselected1: "Satellite",
  crs: L.CRS.EPSG4326,
  attributionControl: false,
  modal: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COMMON_INPUT:
      return {
        ...state,
      };
    case BASE_LAYER_CHANGE:
      return {
        ...state,
        baselayerselected: action.baselayerselected,
        baselayerselected1: action.baselayerselected,
        url: action.url,
        url1: action.url,
        layers: action.layers,
        layers1: action.layers,
      };
    case DISPLAY_BASELAYER_PANEL:
      return {
        ...state,
        baseLayers: action.baselayers,
        baseLayers1: action.baselayers,
      };
    case DISPLAY_ABOUT_MODAL:
      return {
        ...state,
        modal: action.payload,
      };
    default:
      return state;
  }
}
